import { render, staticRenderFns } from "./QuestionnaireThumbnail.vue?vue&type=template&id=e47ab22a&scoped=true&"
import script from "./QuestionnaireThumbnail.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireThumbnail.vue?vue&type=style&index=0&id=e47ab22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47ab22a",
  null
  
)

export default component.exports